import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UserResponse } from 'algorilla-shared-libs';
import { NotificationsService } from 'bowman-angular2-notifications';
import { BowmanCacheService } from 'bowman-cache';
import { HelperFunctions } from 'bowman-commons';
import { BowmanLogger, BowmanLoggerService } from 'bowman-logger';
import { ContextMenuComponent } from 'ngx-contextmenu';
import { Subscription } from 'rxjs';
import { FieldMapping } from 'src/app/dashboard/model/field-mapping';
import { SearchFilter } from 'src/app/dashboard/model/search-filter';
import { SearchResultProperty } from 'src/app/dashboard/model/search-result-property';
import { TypeMappingComponent } from 'src/app/data-types/type-mapping/type-mapping.component';
import { QueryManagerService } from 'src/app/services/query-manager.service';
import { ModalComponent } from 'src/lib/modal/modal.component';
import { SecurityService } from 'src/services/security.service';
import { EventDetailDialog } from './model/event-detail-dialog';
import { DashboardBusService } from './service/dashboard-bus-service';


@Component({
  selector: 'app-event-details-tray',
  templateUrl: './event-details-tray.component.html',
  styleUrls: ['./event-details-tray.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventDetailsTrayComponent implements OnInit {
  private log: BowmanLogger = new BowmanLogger(this._loggerService, "Event details tray component");

  @ViewChild(ModalComponent, { static: false }) eventDetailsModal: ModalComponent;
  @ViewChild(ContextMenuComponent, { static: false }) public eventDetailsContextMenu: ContextMenuComponent;
  public busy: Subscription;
  public user: UserResponse;
  public eventDetailDialogs: Array<EventDetailDialog> = [];
  public fieldMappings: { [name: string]: FieldMapping; };
  public isEventDetailDialogsTrayOpen: boolean = false;
  constructor(
    private _cdr: ChangeDetectorRef,
    private _notificationsService: NotificationsService,
    private _bowmanCacheService: BowmanCacheService,
    private _loggerService: BowmanLoggerService,
    private _queryService: QueryManagerService,
    private _dashboardBusService: DashboardBusService,
    private _securityService: SecurityService,


  ) {
    this._dashboardBusService.listEventDetails().subscribe(eventDetails => {
      this.eventDetailDialogs = eventDetails;
      this._cdr.detectChanges();
    })
  }
  public setSelectedText(item: any): void {
    let searchFilter: SearchFilter = new SearchFilter();
    item.edd.selectedValue = null;
    item.edd.selectedKey = null;
    item.edd.parsedText = null;
    item.edd.tokenization = null;
    if (window.getSelection && window.getSelection().toString() != '') {
      item.edd.selectedValue = window.getSelection().toString();
    } else {
      item.edd.selectedKey = item.key;
      item.edd.selectedValue = item.value;
    }
  }

  isMarkdown(value: string): boolean {
    if (value != null) {
      return value.toString().startsWith('md[') && value.toString().endsWith(']');
    } else {
      return false;
    }

  }
  parseMarkdown(value: string): string {
    if (value.startsWith('md[') && value.endsWith(']')) {
      return value.slice(3, -1);
    }

    return value;
  }
  isPropertyAvailable(propertyName: string, properties: Array<SearchResultProperty>): boolean {
    let found = false;
    properties.map(prop => {
      if (prop.key == propertyName) {
        found = true;
      }
    })
    return found;
  }
  getPropertyValue(propertyName: string, properties: Array<SearchResultProperty>): any {
    let result: any = '-';
    properties.map(prop => {
      if (prop.key == propertyName) {
        result = prop.value;
      }
    });
    return result;
  }

  public setQueryString(event: any) {
    let queryString: string = null;
    if (event && event.item && event.item.selectedValue != null) {
      if (event.item.selectedKey != null) {
        queryString = event.item.selectedKey + ': "' + event.item.selectedValue + '"';
      } else {
        queryString = '"' + event.item.selectedValue + '"';
      }
    } else {
      queryString = event;
    }

    let searchFilter: SearchFilter = new SearchFilter();
    searchFilter.value = queryString;
    this._dashboardBusService.pushFilter(null, searchFilter);
    this._dashboardBusService.doSearch();
  }

  public parseJson(event: any, eventDetailDialog?: EventDetailDialog) {
    if (event && event.item && event.item.selectedValue) {
      event.item.parsedText = null;
      try {
        event.item.parsedText = JSON.parse(event.item.selectedValue);
      } catch (err) {
        // try to escape backslashes in escaped json
        try {
          event.item.parsedText = JSON.parse(event.item.selectedValue.replace(/\\/g, ""));
        } catch (err2) {
          // try to parse as XML
          if (event.item.selectedValue.substring(0, 1) == '<') {
            event.item.parsedText = this.formatXml(event.item.selectedValue.replace(/\\/g, ""));
          } else {
            event.item.parsedText = event.item.selectedValue;
          }
        }
      }
    } else if (eventDetailDialog && event && event != null && event != '') {
      eventDetailDialog.parsedText = null;
      try {
        eventDetailDialog.parsedText = JSON.parse(event);
      } catch (err) {
        // try to escape backslashes in escaped json
        try {
          eventDetailDialog.parsedText = JSON.parse(event.replace(/\\/g, ""));
        } catch (err2) {
          // try to parse as XML
          try {
            eventDetailDialog.parsedText = this.formatXml(event.replace(/\\/g, "").split('&lt;').join('<').split("&gt;").join('>'));
          } catch (xmlErr) {
            eventDetailDialog.parsedText = event;

          }
        }

      }
    }
    let element: Element = document.querySelector("#eventDetails-" + (eventDetailDialog ? eventDetailDialog.id : (event && event.item && event.item.id) ? event.item.id : null));
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
    this._cdr.detectChanges();
  }

  public showTokenization(event: any, eventDetailDialog?: EventDetailDialog) {
    let textToParse: string = null;
    let element: Element = document.querySelector("#eventDetails-" + (eventDetailDialog ? eventDetailDialog.id : (event && event.item && event.item.content) ? event.item.id : null));
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
    if (event && event.item && event.item.selectedValue) {
      textToParse = event.item.selectedValue;
    } else if (eventDetailDialog && event && event != null && event != '') {
      textToParse = event;
      eventDetailDialog.tokenization = null;
    }

    this._queryService.testTokenization(textToParse).subscribe(res => {
      if (res.status == 'OK') {
        if (eventDetailDialog) {
          eventDetailDialog.tokenization = res.result;
        } else if (event.item) {
          event.item.tokenization = res.result;
        }
        this._cdr.detectChanges();
      } else {
        this._notificationsService.error("Unable to show tokenization for selected value", res.message);
      }
    }, err => {
      this._notificationsService.error("Unable to show tokenization for selected value", err);
    })
  }

  public minimizeEventDetailsModal(eventDetailDialog: EventDetailDialog) {
    eventDetailDialog.minimized = true;
  }
  public maximizeEventDetailsModal(eventDetailDialog: EventDetailDialog) {
    eventDetailDialog.minimized = false;
  }

  public closeEventDetailsModal(eventDetailDialog: EventDetailDialog) {
    this._dashboardBusService.removeEventDetail(eventDetailDialog);

  }
  public saveEventDetails(eventDetailDialogs: Array<EventDetailDialog>) {
    eventDetailDialogs.forEach(ed => { ed.selectedKey = null, ed.selectedValue = null, ed.parsedText = null; ed.minimized = true; });
    this.user.options['eventDetailDialogs'] = JSON.stringify(HelperFunctions.cloneObject(eventDetailDialogs));
    this.busy = this._securityService.updateUserOptions(this.user.options).subscribe(res => {
      if (res.status == 'OK') {
        this.user.options = this.user.options;
        this._notificationsService.success("Event detail dialogs saved successfully.");
        this._bowmanCacheService.set('user', this.user);
        this._cdr.detectChanges();
      } else {
        this._notificationsService.error("Unable to save event detail dialogs", res.message);
        this.log.error("Unable to save event detail dialogs", res.message);
      }
    }, err => {
      this._notificationsService.error("Unable to save event detail dialogs", err);
      this.log.error("Unable to save event detail dialogs", err);
    });
  }

  ngOnInit() {
    this.log.info("Component init.")
    if (this._bowmanCacheService.has('algorilla_user')) {
      this._bowmanCacheService.get('algorilla_user').subscribe(user => {
        this.user = user;
        this.busy = TypeMappingComponent.getFieldsMapping(this._bowmanCacheService, this._queryService).subscribe(res => {
          this.fieldMappings = res;
          if (this.user.options && this.user.options['eventDetailDialogs']) {
            this.eventDetailDialogs = JSON.parse(HelperFunctions.cloneObject(this.user.options['eventDetailDialogs']));
            this.eventDetailDialogs.forEach(edd => {
              this._dashboardBusService.addEventDetail(edd);
              edd.minimized = true;
            });
          }
          this._cdr.detectChanges();
        }, err => {
          this._notificationsService.error('Cannot get field mappings', err);
        });

      });


    } else {
      this.user = null;
      this._notificationsService.error('Cannot get user information');
    }

  }
  public isUrl(text: string): boolean {
    var expression = '^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';
    var regex = new RegExp(expression);
    if (typeof text != 'undefined' && text != null) {
      if (text.toString().match(regex)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  public formatXml(xml): string {
    var reg = /(>)\s*(<)(\/*)/g; // updated Mar 30, 2015
    var wsexp = / *(.*) +\n/g;
    var contexp = /(<.+>)(.+\n)/g;
    xml = xml.replace(reg, '$1\n$2$3').replace(wsexp, '$1\n').replace(contexp, '$1\n$2');
    var pad = 0;
    var formatted = '';
    var lines = xml.split('\n');
    var indent = 0;
    var lastType = 'other';
    // 4 types of tags - single, closing, opening, other (text, doctype, comment) - 4*4 = 16 transitions 
    var transitions = {
      'single->single': 0,
      'single->closing': -1,
      'single->opening': 0,
      'single->other': 0,
      'closing->single': 0,
      'closing->closing': -1,
      'closing->opening': 0,
      'closing->other': 0,
      'opening->single': 1,
      'opening->closing': 0,
      'opening->opening': 1,
      'opening->other': 1,
      'other->single': 0,
      'other->closing': -1,
      'other->opening': 0,
      'other->other': 0
    };

    for (var i = 0; i < lines.length; i++) {
      var ln = lines[i];

      // Luca Viggiani 2017-07-03: handle optional <?xml ... ?> declaration
      if (ln.match(/\s*<\?xml/)) {
        formatted += ln + "\n";
        continue;
      }
      // ---

      var single = Boolean(ln.match(/<.+\/>/)); // is this line a single tag? ex. <br />
      var closing = Boolean(ln.match(/<\/.+>/)); // is this a closing tag? ex. </a>
      var opening = Boolean(ln.match(/<[^!].*>/)); // is this even a tag (that's not <!something>)
      var type = single ? 'single' : closing ? 'closing' : opening ? 'opening' : 'other';
      var fromTo = lastType + '->' + type;
      lastType = type;
      var padding = '';

      indent += transitions[fromTo];
      for (var j = 0; j < indent; j++) {
        padding += '\t';
      }
      if (fromTo == 'opening->closing')
        formatted = formatted.substr(0, formatted.length - 1) + ln + '\n'; // substr removes line break (\n) from prev loop
      else
        formatted += padding + ln + '\n';
    }

    return formatted;
  };


  public getProperty(propertyName: string, searchResultProperties: Array<SearchResultProperty>): SearchResultProperty {
    if (searchResultProperties.find(p => p.key == propertyName)) {
      return searchResultProperties.find(p => p.key == propertyName)
    } else {
      return new SearchResultProperty(propertyName, null);
    }
  }


}
